import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"
function Home() {
  return (
    <>
      <div>
        <header className="header-area">
          <div className="navbar-area">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <Navbar />
                </div>
              </div>
            </div>
          </div>
        </header>

        <div id="home">
          <div className="container mt-125 mb-50">
            <div className="">
              <div className="card-body shadow">
                <h4>Privacy Policy</h4>
                <p>
                  [MXW Apps] built the Android app as a Free app. This SERVICE is
                  provided by [MXW Apps] at no cost and is intended for use as is.
                </p>
                <p>
                  This page is used to inform visitors regarding [my/our] policies
                  with the collection, use, and disclosure of Personal Information if
                  anyone decided to use [my/our] Service.
                </p>{" "}
                <p>
                  If you choose to use [my/our] Service, then you agree to the
                  collection and use of information in relation to this policy. The
                  Personal Information that [I/We] collect is used for providing and
                  improving the Service. [I/We] will not use or share your
                  information with anyone except as described in this Privacy Policy.
                </p>{" "}
                <p>
                  The terms used in this Privacy Policy have the same meanings as in
                  our Terms and Conditions, which is accessible at Kolay Yemek
                  Tarifleri unless otherwise defined in this Privacy Policy.
                </p>{" "}
                <p>
                  <strong>Information Collection and Use</strong>
                </p>{" "}
                <p>
                  For a better experience, while using our Service, [I/We] may
                  require you to provide us with certain personally identifiable
                  information. The information that [I/We] request will be [retained
                  on your device and is not collected by [me/us] in any
                  way]/[retained by us and used as described in this privacy policy].
                </p>{" "}
                <div>
                  <p>
                    The app does use third party services that may collect
                    information used to identify you.
                  </p>{" "}
                  <p>
                    Link to privacy policy of third party service providers used by
                    the app
                  </p>{" "}
                  <ul>
                    <li>
                      <a
                        href="https://www.google.com/policies/privacy/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Google Play Services
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://support.google.com/admob/answer/6128543?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        AdMob
                      </a>
                    </li>
                  </ul>
                </div>
                <p>
                  <strong>Log Data</strong>
                </p>
                <p>
                  [I/We] want to inform you that whenever you use [my/our] Service,
                  in a case of an error in the app [I/We] collect data and
                  information (through third party products) on your phone called Log
                  Data. This Log Data may include information such as your device
                  Internet Protocol (“IP”) address, device name, operating system
                  version, the configuration of the app when utilizing [my/our]
                  Service, the time and date of your use of the Service, and other
                  statistics.
                </p>{" "}
                <p>
                  <strong>Cookies</strong>
                </p>{" "}
                <p>
                  Cookies are files with a small amount of data that are commonly
                  used as anonymous unique identifiers. These are sent to your
                  browser from the websites that you visit and are stored on your
                  device's internal memory.
                </p>{" "}
                <p>
                  This Service does not use these “cookies” explicitly. However, the
                  app may use third party code and libraries that use “cookies” to
                  collect information and improve their services. You have the option
                  to either accept or refuse these cookies and know when a cookie is
                  being sent to your device. If you choose to refuse our cookies, you
                  may not be able to use some portions of this Service.
                </p>{" "}
                <p>
                  <strong>Service Providers</strong>
                </p>{" "}
                <p>
                  [I/We] may employ third-party companies and individuals due to the
                  following reasons:
                </p>{" "}
                <ul>
                  <li>To facilitate our Service;</li>{" "}
                  <li>To provide the Service on our behalf;</li>{" "}
                  <li>To perform Service-related services; or</li>{" "}
                  <li>To assist us in analyzing how our Service is used.</li>
                </ul>{" "}
                <p>
                  [I/We] want to inform users of this Service that these third
                  parties have access to your Personal Information. The reason is to
                  perform the tasks assigned to them on our behalf. However, they are
                  obligated not to disclose or use the information for any other
                  purpose.
                </p>{" "}
                <p>
                  <strong>Security</strong>
                </p>{" "}
                <p>
                  [I/We] value your trust in providing us your Personal Information,
                  thus we are striving to use commercially acceptable means of
                  protecting it. But remember that no method of transmission over the
                  internet, or method of electronic storage is 100% secure and
                  reliable, and [I/We] cannot guarantee its absolute security.
                </p>{" "}
                <p>
                  <strong>Links to Other Sites</strong>
                </p>{" "}
                <p>
                  This Service may contain links to other sites. If you click on a
                  third-party link, you will be directed to that site. Note that
                  these external sites are not operated by [me/us]. Therefore, [I/We]
                  strongly advise you to review the Privacy Policy of these websites.
                  [I/We] have no control over and assume no responsibility for the
                  content, privacy policies, or practices of any third-party sites or
                  services.
                </p>{" "}
                <p>
                  <strong>Children’s Privacy</strong>
                </p>{" "}
                <p>
                  These Services do not address anyone under the age of 13. [I/We] do
                  not knowingly collect personally identifiable information from
                  children under 13. In the case [I/We] discover that a child under
                  13 has provided [me/us] with personal information, [I/We]
                  immediately delete this from our servers. If you are a parent or
                  guardian and you are aware that your child has provided us with
                  personal information, please contact [me/us] so that [I/We] will be
                  able to do necessary actions.
                </p>{" "}
                <p>
                  <strong>Changes to This Privacy Policy</strong>
                </p>{" "}
                <p>
                  [I/We] may update our Privacy Policy from time to time. Thus, you
                  are advised to review this page periodically for any changes.
                  [I/We] will notify you of any changes by posting the new Privacy
                  Policy on this page.
                </p>{" "}
                <p>This policy is effective as of 2020-09-15</p>{" "}
                <p>
                  <strong>Contact Us</strong>
                </p>{" "}
                <p>
                  If you have any questions or suggestions about [my/our] Privacy
                  Policy, do not hesitate to contact [me/us] at
                  web-developer@outlook.com
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Home
